import { CSSProperties, PropsWithChildren } from 'react';

export const MODAL_ANIMATION_TIME = 300;

export type CustomSizeType = {
  width?: string;
  maxWidth?: string;
  height?: string;
  maxHeight?: string;
  minHeight?: string;
  minWidth?: string;
};

export type ModalProps = PropsWithChildren<{
  id?: string;
  open: boolean;
  onRequestClose?: () => void;
  portalClassName?: string;
  contentWrapperClassName?: string;
  contentClassName?: string;
  modalClassName?: string;
  footerClassName?: string;
  backgroundColor?: string;
  animation?: 'slide-up' | 'slide-down' | 'slide-left' | 'slide-right' | 'fade' | 'zoom' | 'rotate' | 'flip' | 'drawer';
  withZoom?: boolean;
  size?: 'small' | 'medium' | 'large' | 'full';
  showBackdrop?: boolean;
  renderHeaderContent?: () => React.ReactNode;
  renderFooterContent?: () => React.ReactNode;
  customSize?: CustomSizeType;
  delayContentRender?: number;
  showLoadingIndicator?: boolean;
  delayRenderLoadingIndicator?: number;
  onTransitionOpening?: () => void;
  onTransitionOpened?: () => void;
  onTransitionClosing?: () => void;
  onTransitionClosed?: () => void;
  fadeTransition?: boolean;
  transitionDuration?: number;
  transitionTimingFunction?: CSSProperties['transitionTimingFunction'];
  animateHeightTransition?: boolean;
  'data-component'?: string;
  drawerMode?: boolean;
}>;
